import { useState, useEffect } from "react";

import { getTotaliserStats } from "../civicrm/totaliser";

export const TotaliserBlock = ({ contributionPage, campaign }) => {
  const [targetMoney, setTargetMoney] = useState(0);
  const [moneyRaised, setMoneyRaised] = useState(0);
  const [moneyRaisedPercentage, setMoneyRaisedPercentage] = useState(0);
  const [progressBarWidth, setProgressBarWidth] = useState(5);
  const [campaignStatusMessage, setCampaignStatusMessage] = useState("");

  useEffect(() => {
    if (campaign || contributionPage) {
      getTotaliserStats(campaign, contributionPage)
        .then((data) => {
          setTargetMoney(data.targetMoney);
          setMoneyRaised(data.moneyRaised);
          setMoneyRaisedPercentage(data.moneyRaisedPercentage);
          setProgressBarWidth(data.progressBarWidth);
          setCampaignStatusMessage(data.campaignStatusMessage);
        })
        .catch((error) => {
          console.log("Error fetching totaliser stats: " + error);
        });
    }
  }, [campaign, contributionPage]);

  return (
    <div className="totaliser-block">
      <div className="progressbar-legend">
        <span>&pound;0</span>
        <span>&pound;{targetMoney}</span>
      </div>
      <div className="progressbar">
        <div style={{ width: `${progressBarWidth}%` }}>
          {moneyRaisedPercentage ? (
            <div className="progressbar-progress">{moneyRaisedPercentage}%</div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="money-total">
        Raised &pound;{moneyRaised} of &pound;{targetMoney}
      </div>
      <div>{campaignStatusMessage}</div>
    </div>
  );
};
